import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Svg from "_assets/svg";
import H5 from "components/H5";

const WrapperValidation = styled.div`
  position: absolute;
  background: #22292f;
  border-radius: 8px;
  padding: 20px;
  z-index: 100;
  min-width: 320px;
  top: 100%;
`;

const Img = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 10px;
`;

const WrapperText = (props) => {
  const { active, description, className } = props;
  return (
    <div className={`d-flex flex-row align-items-center ${className}`}>
      <Img src={active ? Svg.check_true.default : Svg.check_false.default} />
      <H5 className="fw-normal" color="#FFFFFF">
        {description}
      </H5>
    </div>
  );
};

const TextInput = (props) => {
  const {
    onChange,
    title,
    value,
    placeholder,
    prepend,
    id,
    required,
    invalidFeedback,
    tooltipValidation,
    className,
    inputType,
    disabled = false,
    start
  } = props;

  return (
    <div className={className}>
      <label htmlFor={id} className="margin-bottom-5 h4">
        {title} 
        {start && <span className="startRed">*</span>}
      </label>
      <div className="input-group">
        {prepend !== "" && (
          <div className="input-group-prepend">
            <span className="input-group-text" id="inputGroupPrepend">
              {prepend}
            </span>
          </div>
        )}
        <input
          type={inputType || "text"}
          className={`form-control br-8 h4 ${prepend && "br-0-8"}${invalidFeedback && "has-error"}`}
          id={id}
          placeholder={placeholder}
          aria-describedby={prepend ? "inputGroupPrepend" : ""}
          value={value}
          required={required}
          disabled={disabled}
          onChange={onChange}
          autoComplete="off"
        />

        <WrapperValidation
          style={{
            display: tooltipValidation?.visible ? "block" : "none",
            borderRadius: 8,
          }}
          className="tooltip-password-validation"
        >
          {tooltipValidation?.value?.map((item, index) => (
            <WrapperText
              active={item.isValid}
              description={item.msg}
              className={index && "margin-top-10"}
            />
          ))}
        </WrapperValidation>
        <div className="invalid-feedback" style={{ display: invalidFeedback ? "block" : "none" }}>
          {invalidFeedback}
        </div>
      </div>
    </div>
  );
};

TextInput.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  prepend: PropTypes.string,
  required: PropTypes.bool,
  invalidFeedback: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  inputType: PropTypes.number,
};

TextInput.defaultProps = {
  title: "",
  value: "",
  placeholder: "",
  prepend: "",
  required: false,
  invalidFeedback: "",
  className: "",
  inputType: ""
};

export default TextInput;
